// Rollen-Texte und die Identität der Shells (aus GET /api/core/me). Ob eine Plattform offen ist,
// entscheidet der Server (`/me.platforms`, UX A9).
import type { RoleKey } from '@web/registry/types';

const ROLE_LABELS: Record<RoleKey, string> = {
  EMP: 'Employee',
  LM: 'Line manager',
  OM: 'Other manager',
  HOD: 'Head of department',
  PERF: 'Performance team',
  COMP: 'Compensation',
  HR: 'HR',
  CL: 'C-level',
  CEO: 'CEO',
  ADM: 'Admin',
  OWN: 'App owner',
};

/** Rollen-Chips: ohne „Employee“, wenn es weitere gibt; wichtigste zuerst. */
export function roleChips(roles: readonly RoleKey[]): string[] {
  const order: RoleKey[] = [
    'CEO',
    'ADM',
    'CL',
    'PERF',
    'COMP',
    'HR',
    'HOD',
    'LM',
    'OWN',
    'OM',
    'EMP',
  ];
  const sorted = order.filter((r) => roles.includes(r));
  const shown = sorted.length > 1 ? sorted.filter((r) => r !== 'EMP') : sorted;
  return shown.slice(0, 3).map((r) => ROLE_LABELS[r]);
}

export interface ShellIdentity {
  accountId: string;
  employeeId: string | null;
  name: string;
  email: string;
  roles: readonly RoleKey[];
  persona?: string;
  platforms: { people: boolean; admin: boolean; ai: boolean };
  authMode: 'supabase' | 'local' | 'demo';
}
